<div class="dates-line">
    <div class="date">
        <div class="placeholder">{{ startTimePlaceholder | translate }}</div>
        <app-basic-input
            [classes]=""
            [formControl]="startTime"
            [inputConfig]="startTimeConfig"
            [isValid]="startTime.valid"
            [readOnly]="readonly.start"
        >
            <app-form-errors
                *ngIf="startTime.touched"
                [errors]="startTime.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>
    <div class="date">
        <div class="placeholder">{{ endTimePlaceholder | translate }}</div>
        <app-basic-input
            [classes]=""
            [formControl]="endTime"
            [inputConfig]="endTimeConfig"
            [isValid]="endTime.valid"
            [readOnly]="readonly.end"
        >
            <app-form-errors
                *ngIf="endTime.touched"
                [errors]="endTime.errors"
                (errorDisplay)="elementSizeModification.emit()"
            ></app-form-errors>
        </app-basic-input>
    </div>
</div>
